var map = {
	".": [
		80294
	],
	"./": [
		80294
	],
	"./core-exchange": [
		17902
	],
	"./core-exchange/": [
		17902
	],
	"./core-exchange/4.6/corex.yml": [
		99979
	],
	"./core-exchange/5.0/corex.yml": [
		22092
	],
	"./core-exchange/5.1/corex.yml": [
		78989
	],
	"./core-exchange/5.2/corex.yml": [
		378
	],
	"./core-exchange/5.3/corex.yml": [
		1611
	],
	"./core-exchange/6.0/corex.yml": [
		63879
	],
	"./core-exchange/6.1/corex.yml": [
		8230
	],
	"./core-exchange/6.2/corex.yml": [
		20425
	],
	"./core-exchange/6.3/corex.yml": [
		41224
	],
	"./core-exchange/6.4/corex.yml": [
		40251
	],
	"./core-exchange/index": [
		17902
	],
	"./core-exchange/index.tsx": [
		17902
	],
	"./core-exchange/robinhood-5.1/corex.yml": [
		89128,
		89128
	],
	"./errors.yml": [
		1516,
		1516
	],
	"./exchange": [
		78580
	],
	"./exchange/": [
		78580
	],
	"./exchange/directV1.yml": [
		90671
	],
	"./exchange/index": [
		78580
	],
	"./exchange/index.tsx": [
		78580
	],
	"./index": [
		80294
	],
	"./index.tsx": [
		80294
	],
	"./link": [
		70266
	],
	"./link.tsx": [
		70266
	],
	"./link.yml": [
		80349
	],
	"src/contexts/docs/openapi": [
		80294
	],
	"src/contexts/docs/openapi/": [
		80294
	],
	"src/contexts/docs/openapi/core-exchange": [
		17902
	],
	"src/contexts/docs/openapi/core-exchange/": [
		17902
	],
	"src/contexts/docs/openapi/core-exchange/4.6/corex.yml": [
		99979
	],
	"src/contexts/docs/openapi/core-exchange/5.0/corex.yml": [
		22092
	],
	"src/contexts/docs/openapi/core-exchange/5.1/corex.yml": [
		78989
	],
	"src/contexts/docs/openapi/core-exchange/5.2/corex.yml": [
		378
	],
	"src/contexts/docs/openapi/core-exchange/5.3/corex.yml": [
		1611
	],
	"src/contexts/docs/openapi/core-exchange/6.0/corex.yml": [
		63879
	],
	"src/contexts/docs/openapi/core-exchange/6.1/corex.yml": [
		8230
	],
	"src/contexts/docs/openapi/core-exchange/6.2/corex.yml": [
		20425
	],
	"src/contexts/docs/openapi/core-exchange/6.3/corex.yml": [
		41224
	],
	"src/contexts/docs/openapi/core-exchange/6.4/corex.yml": [
		40251
	],
	"src/contexts/docs/openapi/core-exchange/index": [
		17902
	],
	"src/contexts/docs/openapi/core-exchange/index.tsx": [
		17902
	],
	"src/contexts/docs/openapi/core-exchange/robinhood-5.1/corex.yml": [
		89128,
		89128
	],
	"src/contexts/docs/openapi/errors.yml": [
		1516,
		1516
	],
	"src/contexts/docs/openapi/exchange": [
		78580
	],
	"src/contexts/docs/openapi/exchange/": [
		78580
	],
	"src/contexts/docs/openapi/exchange/directV1.yml": [
		90671
	],
	"src/contexts/docs/openapi/exchange/index": [
		78580
	],
	"src/contexts/docs/openapi/exchange/index.tsx": [
		78580
	],
	"src/contexts/docs/openapi/index": [
		80294
	],
	"src/contexts/docs/openapi/index.tsx": [
		80294
	],
	"src/contexts/docs/openapi/link": [
		70266
	],
	"src/contexts/docs/openapi/link.tsx": [
		70266
	],
	"src/contexts/docs/openapi/link.yml": [
		80349
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 41655;
module.exports = webpackAsyncContext;